import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import type { ListResponse } from "@app/api/client";
import { api } from "@app/api/client";
import type { BackofficeGame, GameStatus } from "@app/api/types";

export interface GameListParams {
  offset: number;
  limit: number;
  q?: string;
  status?: GameStatus;
  organizationId?: number;
}

export function useGames(params: GameListParams) {
  return useQuery({
    queryKey: ["games", params],
    queryFn: async (): Promise<ListResponse<BackofficeGame>> => {
      const query: Record<string, string | number> = { offset: params.offset, limit: params.limit };
      if (params.q) query.q = params.q;
      if (params.status) query.status = params.status;
      if (params.organizationId) query.organizationId = params.organizationId;
      const { data } = await api.get<ListResponse<BackofficeGame>>("/admin/games", { params: query });
      return data;
    }
  });
}

export function useSetGameArchived() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, archived }: { id: number; archived: boolean }): Promise<BackofficeGame> => {
      const { data } = await api.post<BackofficeGame>(`/admin/games/${id}/${archived ? "disable" : "enable"}`);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["games"] });
    }
  });
}
